/**
 * Observability User
 *
 * Keeps the observability manager's user (Sentry's, on both platforms) in step
 * with the signed-in account, so an error shows whose session it came from and
 * an issue counts the people it reached.
 *
 * The user is the account's username: accounts have no other stable id, and
 * the username is the public handle, not an email (PRD decision 11). The
 * manager passes on `id` alone.
 *
 * `trackObservabilityUser()` is called by each platform right after it
 * registers its providers: it sets whoever is signed in now (a restored
 * session is already in the store by then) and follows every later sign-in,
 * sign-out and account switch through the session boundary.
 */

import { authStore } from './auth.store';
import { registerSessionScoped } from './session-scope';
import { getObservability } from '../di/container';

const setObservabilityUser = (username: string | null): void => {
  getObservability().setUser(username ? { id: username } : null);
};

export function trackObservabilityUser(): void {
  // `account`: a role switch keeps the same person.
  registerSessionScoped(
    'observability-user',
    ({ next }) => setObservabilityUser(next),
    { scope: 'account' }
  );
  setObservabilityUser(authStore.getState().user?.username ?? null);
}
